<dm-card class="lp-info-panel">
  <dm-card-body>
    <span class="dm-text-sm dm-color-text-tertiary" i18n="@@benutzerverwaltung.benachrichtigungen.hinweis"
      >Benachrichtigungen werden immer an die E-Mail des Benutzers versendet.</span
    >
  </dm-card-body>
</dm-card>

<dm-content-divider variant="line" class="dm-margin-top-24" />

<div class="dm-margin-top-24 dm-grid dm-grid-cols-1 desktop:dm-grid-cols-12 dm-gap-16">
  <div class="desktop:dm-grid-col-span-4">
    <dm-label-section label="Newsletter Abonnieren" i18n-label="@@benutzerverwaltung.benachrichtigungen.newsletter" />
  </div>
  <div class="desktop:dm-grid-col-span-8 dm-flex dm-flex-column dm-gap-16">
    <dm-switch
      label="Newsletter Versand"
      i18n-label="@@benutzerverwaltung.benachrichtigungen.newsletterVersand"
      [checked]="newsletterAktiv()"
      [disabled]="disabled()"
      (checkedChange)="onNewsletterAktivChange($event)"
    />
    @if (newsletterAktiv()) {
      <dm-select
        [attr.aria-label]="newsletterIntervallAriaLabel"
        placeholder="Bitte wählen"
        i18n-placeholder="@@common.pleaseSelect"
        [value]="(newsletterPeriod() ?? intervalle[0]).toString()"
        [disabled]="disabled()"
        (dmChange)="onNewsletterPeriodChange($event.detail.value)"
      >
        @for (months of intervalle; track months) {
          <dm-select-item [value]="months.toString()">{{ intervallLabel(months) }}</dm-select-item>
        }
      </dm-select>
    }
  </div>
</div>

<dm-content-divider variant="line" class="dm-margin-top-24" />

<div class="dm-margin-top-24 dm-grid dm-grid-cols-1 desktop:dm-grid-cols-12 dm-gap-16">
  <div class="desktop:dm-grid-col-span-4">
    <dm-label-section label="Lexplus Benachrichtigungen" i18n-label="@@benutzerverwaltung.benachrichtigungen.lexplus" />
  </div>
  <div class="desktop:dm-grid-col-span-8">
    <dm-switch
      label="Benachrichtigungen zulassen"
      i18n-label="@@benutzerverwaltung.benachrichtigungen.zulassen"
      hint="Der übergeordnete Schalter für alle E-Mails an diesen Benutzer, ausgenommen Newsletter sowie Passwort- und Sicherheitsmails."
      i18n-hint="@@benutzerverwaltung.benachrichtigungen.zulassenHint"
      [checked]="emailBenachrichtigungenAktiv()"
      [disabled]="disabled()"
      (checkedChange)="changed.emit({ emailBenachrichtigungenAktiv: $event })"
    />
  </div>
</div>

<dm-content-divider variant="line" class="dm-margin-top-24" />

<div class="dm-margin-top-24 dm-grid dm-grid-cols-1 desktop:dm-grid-cols-12 dm-gap-16">
  <div class="desktop:dm-grid-col-span-4">
    <dm-label-section label="Aufgaben" i18n-label="@@common.aufgaben" />
  </div>
  <div class="desktop:dm-grid-col-span-8">
    <!-- One switch, not the four the design draws: `AufgabenBenachrichtigungenAktiv` governs
         every Aufgaben notification type at once, and there is no column per type. -->
    <dm-switch
      label="Aufgaben Aktivitäten"
      i18n-label="@@benutzerverwaltung.benachrichtigungen.aufgabenAktivitaeten"
      hint="Zuweisungen, Änderungen, Fälligkeiten und die Aufgabenübersicht — versendet als eine Tages-Zusammenfassung."
      i18n-hint="@@benutzerverwaltung.benachrichtigungen.aufgabenHint"
      [checked]="aufgabenBenachrichtigungenAktiv()"
      [disabled]="disabled() || !emailBenachrichtigungenAktiv()"
      (checkedChange)="changed.emit({ aufgabenBenachrichtigungenAktiv: $event })"
    />
  </div>
</div>
